var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seurantajakso-container"},[(_vm.$isErikoistuva())?_c('seurantajakso-view-erikoistuja'):_vm._e(),(_vm.$isKouluttaja() || _vm.$isVastuuhenkilo())?_c('seurantajakso-view-kouluttaja-vastuuhenkilo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }